module.exports = __webpack_public_path__ + "img/normative-data.b55646fe.png";